import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Phone, Recycle } from "lucide-react";
import { BRAND, PHONE_TEL } from "../../data/site";

const NAV = [
  { label: "Home", href: "#top" },
  { label: "Services", href: "#categories" },
  { label: "About", href: "#why-us" },
  { label: "Contact", href: "#contact" },
];

export default function StickyHeader() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -90, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      data-testid="sticky-header"
      className={`fixed top-0 left-0 z-50 w-full backdrop-blur-xl transition-[background-color,border-color,box-shadow] duration-300 ${
        scrolled
          ? "border-b border-line/70 bg-white/85 shadow-[0_10px_40px_rgba(10,25,47,0.08)]"
          : "border-b border-transparent bg-white/50"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-5 sm:px-8 md:h-20">
        <a href="#top" data-testid="header-logo" className="flex items-center gap-2.5">
          <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-brand text-white">
            <Recycle className="h-5 w-5" />
          </span>
          <span className="whitespace-nowrap font-display text-sm font-bold tracking-tight text-ink sm:text-lg">
            {BRAND}
          </span>
        </a>

        <nav data-testid="header-nav" className="hidden items-center gap-8 lg:flex">
          {NAV.map((item, i) => (
            <a
              key={item.href}
              href={item.href}
              className={`text-sm transition-colors duration-200 ${
                i === 0 ? "font-semibold text-ink" : "font-medium text-steel/80 hover:text-brand"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2.5">
          <a
            href={PHONE_TEL}
            data-testid="header-call-button"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-brand px-4 py-2.5 text-sm font-semibold text-white shadow-md shadow-brand/30 transition-colors duration-200 hover:bg-brand-dark sm:px-5"
          >
            <Phone className="h-4 w-4" />
            Call Now
          </a>
        </div>
      </div>
    </motion.header>
  );
}
